'use strict';
//library
var React = require('react');
var classNames = require('classnames');
var _ = require('lodash');
var Products = require('../../utils/Products.js');
var Formatter = require('../../utils/Formatter');
var Validators = require('../../utils/Validators');
//store
var RegularInvestmentPlanStore = require('../../stores/RegularInvestmentPlanStore.js');
//Action
var RegularInvestmentPlanAction = require('../../actions/RegularInvestmentPlanActions.js');
var ApplicationActions = require('../../actions/ApplicationActions.js');
//component
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var TextInput = require('../Common/TextInput.jsx');
var SpecifyBankAccountList = require('../Common/SpecifyBankAccountList.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
//constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var Constants = require('../../constants/RegularInvestmentPlanConstants.js');
var ProductIds = require('../../constants/ApplicationConstants').ProductIds;

var eligibleContribution = {
    hidePersonal: true,
    hideSpouse: true
};

function getStateFromStores() {
    return {
        setupError: RegularInvestmentPlanStore.getSetupRIPErrorState(),
        eligibleContribution: RegularInvestmentPlanStore.getEligibleContribution() ? RegularInvestmentPlanStore.getEligibleContribution() : eligibleContribution,
        specificBankAccounts: RegularInvestmentPlanStore.getSpecificBankAccounts(),
        model: RegularInvestmentPlanStore.getRegInvstPlanModel(),
        formError: RegularInvestmentPlanStore.getFormError(),
        showBankAccountList: RegularInvestmentPlanStore.showBankAccountList(),
        showRipSection: RegularInvestmentPlanStore.showRipSection()
    };
}

var RegularInvestmentPlan = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },
    componentDidMount: function () {
        RegularInvestmentPlanStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        RegularInvestmentPlanStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState(getStateFromStores());
    },
    componentDidUpdate: function () {
        ApplicationConstants.FormModel.form.regularInvestmentPlan.ripOption = this.state.model.ripOption;
    },
    componentWillUpdate: function(nextProps, nextState) {
        if (Products.isInvestment(this.props.productId) && !_.isEqual(nextState.model, this.state.model)) {
            ApplicationActions.sendBankAccountFromRip(nextState.formError, nextState.model);
        }
        if (!_.isEqual(nextState.model, this.state.model)) {
            ApplicationActions.sendRipModel(nextState.model);
        }
        if (!_.isEqual(nextState.eligibleContribution, this.state.eligibleContribution)) {
            ApplicationActions.sendEligibleContributionFromRip(nextState.eligibleContribution);
        }
        if (!_.isEqual(nextState.showRipSection, this.state.showRipSection)) {
            ApplicationActions.sendShowRipSection(nextState.showRipSection);
        }
    },
    handleUpdateRip: function (e) {
        var fieldId = e.target.model;
        var value = e.target.value;
        RegularInvestmentPlanAction.updateRIPData(fieldId, value);
    },
    handleSetupSelection: function (e) {
        //broadcast the value of ripOption when it changes and the product is investment
        if (Products.isInvestment(this.props.productId) && Validators.requiredValidation(e.target.value)) {
            ApplicationActions.sendRipAnswer(e.target.value);
        }
        RegularInvestmentPlanAction.validateRegularInvestmentPlan(e.target.value, this.props.productId, this.props.userType, this.props.accountType);
    },
    handleSameAsInvestAllocationOption: function (e) {
        var data = this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES ? '' : e.target.value;
        RegularInvestmentPlanAction.monthlyAmountAllocation(data);
    },
    handleQtyOnBlur: function (e) {
        RegularInvestmentPlanAction.updateRIPInvestAllocationQty(e.target.id, e.target.value);
    },
    handleKeySelection: function (event) {
        if (event.keyCode === 32 || (event.keyCode >= 37 && event.keyCode <= 40)) {
            var value = document.getElementById(event.target.htmlFor).attributes.getNamedItem('value').value;
            this.handleSameAsInvestAllocationOption({ target: { value: value } });
            event.stopPropagation();
            event.preventDefault();
        }
    },
    handleMouseDown: function (event){
        event.preventDefault();
        event.stopPropagation();
    },
    render: function () {
        var sectionHelpText = '',
            taxDeductionHelpText = null,
            accountInDifferentNameHelpText = null,
            provideBankDetailsHelpText = null,
            contribution = null,
            specifyBankAccount = null,
            nominateOtherAccount = null,
            investmentTable = null,
            monthlyAmount = null,
            copyText = this.props.content.regularInvestmentPlan;

        var hideSubSections = (!this.state.setupError || this.state.model.ripOption === '' || this.state.model.ripOption === ApplicationConstants.YesNoValues.NO);

        var showRipSection = (this.props.productId === ProductIds.SUPER && !this.state.showRipSection);

        //error message
        var personalContriHasError = _.filter(this.state.formError.errorList, { id: 'ripPersonalContributionText'});
        var spouseContriHasError = _.filter(this.state.formError.errorList, { id: 'ripSpouseContributionText' });
        var accountNumberError = _.filter(this.state.formError.errorList, { id: 'ripBankAccountText' });

        //Help 1 & Help 2
        var productCopyText = copyText[this.props.productId];
        if (productCopyText) {
            sectionHelpText = productCopyText.sectionHelp;
        }

        //M2-Tax deduction
        //We make sure the personal & spouse contribution no error
        var personal = this.state.model.personalContribution;

        if(personalContriHasError.length === 0) {
            if (_.sum([Formatter.currencyUnformat(personal)]) > 0) {
                taxDeductionHelpText = <InlineMessage id="ripTaxDeduction"
                                                      type="info" message={copyText.taxDeductionHelp}
                                                      isHidden={false} />;
            }
        }

        //M5-Account in different name
        if(this.state.model.bankAccountHeldOption === ApplicationConstants.YesNoValues.NO){
            accountInDifferentNameHelpText = copyText.accountInDifferentNameHelp;
        }

        //M4-Future requests
        if(accountNumberError.length === 0 && this.state.model.bankAccount){
            provideBankDetailsHelpText = copyText[this.props.productId].futureRequestsHelp;
        }


        var contributionInlineError = function(data, index){
            if(data.id === 'ripPersonalContributionText' || data.id === 'ripSpouseContributionText'){
                return (<InlineMessage id={data.id} key={index} isHidden={false} type="error" message={data.message} />);
            }
        };

        var investmentAllocationInlineError = function(data, index){
            if(_.startsWith(data.id, Constants.RIP_INV_OPT_PREFIX)){
                return (<InlineMessage id={data.id} key={index} customClass="alert-right" isHidden={false} type="error" message={data.message} />);
            }
        };

        var amountPerMonth = function(data, index){
            if(data.id === 'ripContributionSection'){
                return (<InlineMessage id={data.id} key={index} isHidden={false} type="error" message={data.message} />);
            }
        }

        //Display the list of investment allocation
        var investmentAllocationList = function (data, index) {
            var idx = Constants.RIP_INV_OPT_PREFIX + index.toString();
            return (
                <tr key={index}>
                    <td className="form-select table-vote">{data.name}</td>
                    <td className="form-select table-vote">{data.code}</td>
                    <td className="form-select table-vote">
                        <TextInput id={idx}
                                   value={data.weight}
                                   onBlur={this.handleQtyOnBlur}
                                   className="rip-investment-allocation-weight pull-right"
                                   isDisabled={this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES}
                                   hasWarning={!data.isValid} />
                    </td>
                </tr>
        )};

        if (this.props.productId !== ProductIds.INVESTMENT && !hideSubSections) {
            contribution =
        <div className="rip-contribution">
                <div id="ripContributionSection" className={classNames('form-section',{hidden: this.state.eligibleContribution.hidePersonal && this.state.eligibleContribution.hideSpouse})}>
                    <table id="ripContributionTypeTable" className="table table-single">
                        <thead>
                            <tr>
                                <td className="column-heading">CONTRIBUTION TYPE<span className="hidden-xs"></span></td>
                                <td className="column-heading"><span className="hidden-xs">AMOUNT PER MONTH</span></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={classNames({hidden: this.state.eligibleContribution.hidePersonal})}>
                                <td className="col-md-6">Personal contribution</td>
                                <td>
                                    <TextInput id="ripPersonalContributionText"
                                               model="personalContribution"
                                               symbol="currency"
                                               value={this.state.model.personalContribution}
                                               onBlur={this.handleUpdateRip}
                                               className="text-input-amount"
                                               hasWarning={personalContriHasError.length > 0} />
                                </td>
                            </tr>
                            <tr className={classNames({hidden: this.state.eligibleContribution.hideSpouse})}>
                                <td className="col-md-6">Spouse contribution</td>
                                <td>
                                    <TextInput id="ripSpouseContributionText"
                                               model="spouseContribution"
                                               symbol="currency"
                                               value={this.state.model.spouseContribution}
                                               onBlur={this.handleUpdateRip}
                                               className="text-input-amount"
                                               hasWarning={spouseContriHasError.length > 0} />
                                </td>
                            </tr>
                        </tbody>
                    <tfoot>
                        <tr>
                            <td className="text-right" aria-label="Total - ${'$' + this.state.model.totalContribution}"><span className="total">Total:</span></td>
                            <td className="table-percent"><span><strong className="currency">$</strong><strong>{this.state.model.totalContribution}</strong></span></td>
                        </tr>
                    </tfoot>
                    </table>
                    {taxDeductionHelpText}
                    {this.state.formError.errorList.length > 0 ? (this.state.formError.errorList).map(contributionInlineError) : null}
                    {this.state.formError.errorList.length > 0 ? (this.state.formError.errorList).map(amountPerMonth) : null}

                </div>
        </div>;
        }

        if (this.props.productId === ProductIds.INVESTMENT && !hideSubSections) {
            monthlyAmount =
            <div id="ripMonthlyAmountContribution">
                <TextInput id="ripMonthlyAmountContributionText"
                           model="monthlyAmountContribution"
                           label="Enter monthly amount"
                           symbol="currency"
                           value={this.state.model.monthlyAmountContribution}
                           onBlur={this.handleUpdateRip}
                           className="text-input-amount"
                           errorList={this.state.formError.errorList} />
            </div>;
        }

        if (!hideSubSections && this.state.showBankAccountList) {
            specifyBankAccount = <SpecifyBankAccountList id="ripBankAccountsList"
                                                         model="selectedBankAccount"
                                                         tableId="ripSpecifyBankAccountTable"
                                                         data={this.state.specificBankAccounts}
                                                         checked={this.state.model.selectedBankAccount}
                                                         onChange={this.handleUpdateRip}
                                                         label="Debit regular investment plan amount from:"
                                                         isValid={this.state.formError.listBankAccountRequiredValid}
                                                         errorMessage={copyText.listBankAccountInline} />;
        }
        if (!hideSubSections && (!this.state.showBankAccountList || this.state.model.selectedBankAccount === Constants.NOMINATE_OTHER_ACCOUNT)) {
            nominateOtherAccount =
                 <div id="ripNominatedOtherAccount">
                        <div id="ripNameOfAccountHolder">
                             <TextInput id="ripNameOfAccountHolderText"
                                        model="nameOfAccountHolder"
                                        label="Name of account holder"
                                        value={this.state.model.nameOfAccountHolder}
                                        onBlur={this.handleUpdateRip}
                                        errorList={this.state.formError.errorList} />
                        </div>

                        <div id="ripNominatedAccountHolderOption">
                            <RadioInput id="ripBankAccountHeldOption"
                                        model="bankAccountHeldOption"
                                        data={ApplicationConstants.YesNoRadioData}
                                        value={this.state.model.bankAccountHeldOption}
                                        label="Is this bank account held in the same name(s) as this application?"
                                        onChange={this.handleUpdateRip}
                                        errorList={this.state.formError.errorList}
                                        contextualMessage={accountInDifferentNameHelpText} />
                        </div>

                        <div id="ripBranchNumber">
                            <TextInput id="ripBranchNumberText"
                                       model="branchNumber"
                                       label="Branch number (BSB)"
                                       value={this.state.model.branchNumber}
                                       onBlur={this.handleUpdateRip}
                                       errorList={this.state.formError.errorList} />
                        </div>

                        <div id="ripBankAccount">
                            <TextInput id="ripBankAccountText"
                                       model="bankAccount"
                                       label="Account number"
                                       value={this.state.model.bankAccount}
                                       onBlur={this.handleUpdateRip}
                                       errorList={this.state.formError.errorList}
                                       contextualMessage={provideBankDetailsHelpText} />
                        </div>
                        <InlineMessage id="ripNominatedSpecifyBankAccount" type="error"
                                       message={copyText.listBankAccountInline}
                                       isHidden={this.state.formError.specifyBankAccountValid} />
                    </div>;
        }

        if (!hideSubSections) {
            investmentTable =
                <div id="ripInvestmentAllocationTable" className="form-section">
                    <div className="form-label-section">
                        <label tabIndex="0" htmlFor="monthly-allocation">How would you like your monthly amount allocated?</label>
                    </div>
                    <div className="form-select">
                        <label tabIndex="0" className={classNames({'btn-cfs': this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES})} id="ripSameAsInvestAllocationlabel" htmlFor="ripSameAsInvestAllocation" onKeyDown={this.handleKeySelection} onMouseDown={this.handleMouseDown} tabIndex="0">
                            <i className="icon icon-check"></i>
                            <input id="ripSameAsInvestAllocation" type="radio" tabIndex="-1" className="btn-option btn btn-default btn-lg" onChange={this.handleSameAsInvestAllocationOption} value={ApplicationConstants.YesNoValues.YES} checked={this.state.model.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES} />
                        </label>
                        <label tabIndex="0" className="rip-inline-check-box">The same way as my selected initial investment allocation.</label>
                    </div>
                    <InlineMessage id="ripExcludedInvestmentHelp" type="info" message={copyText.excludedInvestmentContextHelp} isHidden={this.state.formError.excludedInvestment} />
                    <div id="ripInvestmentAllocationListTable">
                        <table className="table table-single investment-allocation-table" id="ripInvestmentAllocationList">
                            <thead>
                                <tr>
                                    <td className="column-heading">NAME<span className="hidden-xs"></span></td>
                                    <td className="column-heading"><span className="hidden-xs">CODE</span></td>
                                    <td className="column-heading text-right"><span className="visible-xs-inline investment-header-xs">%</span><span className="hidden-xs">INVESTMENT %</span></td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.model.investmentOptionList.map(investmentAllocationList, this)}
                            </tbody>
                        </table>
                        <div id="ripAllocationPercentage" className="table-percent text-right" aria-label="Total is ${'$' + this.state.model.totalAllocationPercentage}"><span className="total">Total:</span><strong>{this.state.model.totalAllocationPercentage}%</strong></div>
                    </div>
                    {this.state.formError.errorList.length > 0 ? (this.state.formError.errorList).map(investmentAllocationInlineError) : null}

                    <div id="ripConsumerPriceIndex">
                        <RadioInput id="ripConsumerPriceIndexOption"
                                    model="consumerPriceIndex"
                                    data={ApplicationConstants.YesNoRadioData}
                                    value={this.state.model.consumerPriceIndex}
                                    label="Would you like to increase your regular investment plan amount each year by a percentage based on the Consumer Price Index (or 3%, whichever is the greater)?"
                                    onChange={this.handleUpdateRip}
                                    errorList={this.state.formError.errorList} />
                    </div>
                </div>;
        }

        return (
            <div>
                { showRipSection ? null :<div id="ripSection" className="form-step">
                <SectionHeader focus={this.props.focus} sectionName="Regular investment plan" sectionHelpText="Need help?" NeedHelpInfo={sectionHelpText} />
                <div className="container">
                        <div id="regularInvestPlanSetup">
                            <RadioInput id="regularInvestPlanOption"
                                        data={ApplicationConstants.YesNoRadioData}
                                        value={this.state.model.ripOption}
                                        label="Would you like to set up a regular investment plan?"
                                        onChange={this.handleSetupSelection}
                                        errorList={this.state.formError.errorList}
                                        isValid={this.state.setupError} />
                        </div>
                        <InlineMessage id="ripInvestmentOptionsAreOutOfSyncCopy" type="error" message={copyText.investmentOptionsAreOutOfSyncCopyHeading} isHidden={this.state.formError.investmentOptionsAreOutOfSyncCopy} />
                    {contribution}
                    {monthlyAmount}
                    {specifyBankAccount}
                    {nominateOtherAccount}
                    {investmentTable}
                </div>
                </div>}
            </div>
        );
    }
});

module.exports = RegularInvestmentPlan;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/RegularInvestmentPlan/RegularInvestmentPlanSection.jsx